import { H } from "@enpowered/ui";
import clasenames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const ActionButton = ({
  disabled,
  onClick,
  icon,
  text,
  displayAction,
  actionBody
}) => {
  const buttonClass = clasenames(["rounded", "ml-2"], {
    "px-3 py-1 shadow-md border-2 border-solid border-gray-500 rounded-md font-bold text-lg": true,
    "bg-white hover:bg-yellow-400": !disabled,
    "bg-en-gray-200 text-en-gray-500 cursor-not-allowed": disabled
  });
  return (
    <div>
      <button onClick={onClick} disabled={disabled} className={buttonClass}>
        <i className={`fas ${icon ? icon : "fa-plus"} mr-2`} />
        {text}
      </button>
      {displayAction ? actionBody : null}
    </div>
  );
};

ActionButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  displayAction: PropTypes.bool,
  onClick: PropTypes.func,
  actionBody: PropTypes.element,
  disabled: PropTypes.bool
};

export const PageSubheader = ({
  title,
  searchInfo,
  buttonInfo,
  secondaryButtonInfo
}) => {
  // Need to add tabs in the future (add onTabChange)
  return (
    <div className="w-full flex flex-row justify-between">
      {title && (
        <div className="p-2">
          {typeof title === "string" ? <H level={2}>{title}</H> : title}
        </div>
      )}
      {searchInfo && (
        <div className="flex flex-col mt-4 mb-4 ml-2 mr-auto">
          <div className="ml-2 relative">
            <span
              className="fas fa-search text-gray-700 mr-1 absolute"
              style={{ left: 12, top: 14 }}
            />
            <input
              className="border-2 border-gray-400 rounded pl-8 pr-1 py-2"
              type="text"
              placeholder={searchInfo.placeholder}
              value={searchInfo.value}
              onChange={e => searchInfo.handleChange(e.target.value)}
            />
          </div>
        </div>
      )}
      <div className="flex items-center mr-2 py-4">
        {buttonInfo && <ActionButton {...buttonInfo} />}
        {secondaryButtonInfo && <ActionButton {...secondaryButtonInfo} />}
        {/* <IconButton icon="fa-ellipsis-v" /> */}
      </div>
    </div>
  );
};

PageSubheader.propTypes = {
  searchInfo: PropTypes.shape({
    placeholder: PropTypes.string,
    handleChange: PropTypes.func,
    value: PropTypes.string
  }),
  buttonInfo: PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.string,
    displayAction: PropTypes.bool,
    onClick: PropTypes.func,
    actionBody: PropTypes.element,
    disabled: PropTypes.bool
  }),
  secondaryButtonInfo: PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.string,
    displayAction: PropTypes.bool,
    onClick: PropTypes.func,
    actionBody: PropTypes.element,
    disabled: PropTypes.bool
  }),
  title: PropTypes.node
};

export default PageSubheader;
